import { Input, InputContainer, ToggleSpan } from './Toggle.styles';

interface IToggle {
  onToggle: (isToggled: boolean) => void;
  toggled?: boolean;
  disabled?: boolean;
}

/**
 * A toggle switch component that can be controlled externally
 * @param {Object} props - Component props
 * @param {(isToggled: boolean) => void} props.onToggle - Callback function when toggle state changes
 * @param {boolean} [props.toggled=false] - Whether the toggle is in the on state
 * @param {boolean} [props.disabled=false] - Whether the toggle is disabled
 */
const Toggle = ({ toggled = false, onToggle, disabled = false }: IToggle) => {
  const handleToggle = () => {
    if (disabled) return;

    onToggle(!toggled);
  };

  return (
    <InputContainer>
      <Input type='checkbox' onChange={handleToggle} checked={toggled} disabled={disabled} />
      <ToggleSpan />
    </InputContainer>
  );
};

export default Toggle;
